import { render, staticRenderFns } from "./DrugReviewHistory.vue?vue&type=template&id=ec4d709e&scoped=true"
import script from "./DrugReviewHistory.vue?vue&type=script&lang=js"
export * from "./DrugReviewHistory.vue?vue&type=script&lang=js"
import style0 from "./DrugReviewHistory.vue?vue&type=style&index=0&id=ec4d709e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d709e",
  null
  
)

export default component.exports